"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockOfClass = void 0;
function getFunctionName(cls) {
    var ret = cls.toString();
    ret = ret.substr('function '.length);
    ret = ret.substr(0, ret.indexOf('('));
    return ret;
}
function createMockOfClass(cls, name) {
    if (name === void 0) { name = null; }
    var mockName;
    if (name === null) {
        mockName = getFunctionName(cls);
    }
    else {
        mockName = name;
    }
    var methodNames = Object.getOwnPropertyNames(cls.prototype)
        // Don't mock the constructor (maybe?)
        .filter(function (propertyName) { return propertyName !== 'constructor'; })
        // Only mock methods
        .filter(function (propertyName) { return typeof cls.prototype[propertyName] === 'function'; });
    return jasmine.createSpyObj(mockName, methodNames);
}
exports.createMockOfClass = createMockOfClass;
//# sourceMappingURL=testHelpers.js.map